module.exports = __webpack_public_path__ + "static/media/dice-d10.ea6a5429.svg";